import script from "./table-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-editor.vue?vue&type=script&setup=true&lang=ts"

import "./table-editor.vue?vue&type=style&index=0&id=3af67df2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af67df2"]])

export default __exports__